import type { BookEntity } from "./api";

export const ENTITIES: Record<BookEntity, { name: string; currency: "GBP" | "EUR"; tz: string }> = {
  LTD: { name: "Ketosource Limited", currency: "GBP", tz: "Europe/London" },
  OU: { name: "Ketosource OÜ", currency: "EUR", tz: "Europe/Tallinn" },
};
export const FACTORIES: Record<BookEntity, Array<{ id: string; name: string }>> = {
  LTD: [{ id: "PHOENIX", name: "Phoenix" }, { id: "RAIN", name: "Rain Nutrience" }, { id: "UNETTE", name: "Unette" }],
  OU: [{ id: "PRIVATE_VITAMIN", name: "Private Vitamin" }],
};
export function factoryName(id: string): string {
  for (const list of Object.values(FACTORIES)) for (const factory of list) if (factory.id === id) return factory.name;
  return id;
}
export function money(value: string | number | null, currency: "GBP" | "EUR", places = 2): string {
  if (value === null || value === "") return "—";
  return new Intl.NumberFormat("en-GB", { style: "currency", currency, minimumFractionDigits: places, maximumFractionDigits: places }).format(Number(value));
}
export function qty(value: string | number | null, uom: "kg" | "unit"): string {
  if (value === null || value === "") return "—";
  const number = Number(value);
  const formatted = new Intl.NumberFormat("en-GB", { maximumFractionDigits: uom === "kg" ? 3 : 0 }).format(number);
  return uom === "kg" ? `${formatted} kg` : formatted;
}
export function signed(value: string | number, uom: "kg" | "unit"): string {
  const number = Number(value); const body = qty(Math.abs(number), uom);
  return number > 0 ? `+${body}` : number < 0 ? `-${body}` : body;
}
export function todayFor(entity: BookEntity | "all", now: Date = new Date()): string {
  const timeZone = entity === "all" ? "UTC" : ENTITIES[entity].tz;
  return new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}
export function toEntityIso(local: string, entity: BookEntity): string {
  const [date, time] = local.split("T"); const [year, month, day] = date.split("-").map(Number); const [hour, minute] = time.split(":").map(Number);
  const guess = Date.UTC(year, month - 1, day, hour, minute);
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: ENTITIES[entity].tz, hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).formatToParts(new Date(guess));
  const get = (type: string) => Number(parts.find((part) => part.type === type)?.value ?? "0");
  const asIfUtc = Date.UTC(get("year"), get("month") - 1, get("day"), get("hour") % 24, get("minute"));
  const offsetMinutes = Math.round((asIfUtc - guess) / 60000); const sign = offsetMinutes >= 0 ? "+" : "-"; const absolute = Math.abs(offsetMinutes);
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date}T${pad(hour)}:${pad(minute)}:00${sign}${pad(Math.floor(absolute / 60))}:${pad(absolute % 60)}`;
}
export function nowLocalInput(entity: BookEntity, now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: ENTITIES[entity].tz, hour12: false, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }).formatToParts(now);
  const get = (type: string) => parts.find((part) => part.type === type)?.value ?? "00";
  return `${get("year")}-${get("month")}-${get("day")}T${String(Number(get("hour")) % 24).padStart(2, "0")}:${get("minute")}`;
}
export function nowEntityIso(entity: BookEntity, now: Date = new Date()): string { return toEntityIso(nowLocalInput(entity, now), entity); }
export function shortId(id: string): string { return id.slice(0, 8); }
